import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { SportsKabaddi } from '@mui/icons-material';
import { areClassNamePropsEqual } from '../utilities/utils';
import { owners_page, navigateToPage } from '../controls/ProtectedPage';

const OwnersButton = ({ className, onClick }: { className?: string, onClick?: () => void }): JSX.Element => {
    const history = useNavigate();
    return (
        <Button variant="contained" color="primary" className={`${className} navActionButton`}
            data-targetid="owners"
            title="View all the owners set up in the system, these are templates that apply to your settings - some are designed by real users"
            onClick={() => {
                if (onClick) onClick();
                setTimeout(() => navigateToPage(owners_page, history), 500);
            }}>
            <span className="navButtonText">
                <SportsKabaddi fontSize='medium' />
                {'Owners '}
            </span>
        </Button>
    )
};

export default memo(OwnersButton, areClassNamePropsEqual);
